import React from "react";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import getMuiTheme from "material-ui/styles/getMuiTheme";
import IconButton from "material-ui/IconButton";
import IconMenu from "material-ui/IconMenu";
import MenuItem from "material-ui/MenuItem";
import EditIcon from "material-ui/svg-icons/editor/mode-edit";
import NotifyIcon from "material-ui/svg-icons/social/notifications-active";
import MoreVertIcon from "material-ui/svg-icons/navigation/more-vert";
import RefreshIcon from "material-ui/svg-icons/navigation/refresh";
import TextField from "material-ui/TextField";
import { Link } from "react-router-dom";
import { Card, CardHeader, CardText } from "material-ui/Card";
import { Toolbar, ToolbarGroup, ToolbarTitle } from "material-ui/Toolbar";
import IzvestajiIcon from "material-ui/svg-icons/social/poll";
import RadniciIcon from "material-ui/svg-icons/social/person";
import PinIcon from "material-ui/svg-icons/action/lock";
import JelovnikIcon from "material-ui/svg-icons/action/date-range";
import RadniciIconAdd from "material-ui/svg-icons/social/person-add";
import * as Colors from "material-ui/styles/colors";
import "./firmeDash.css";

const muiTheme = getMuiTheme({
  palette: {
    textColor: Colors.darkBlack,
    primary1Color: Colors.lightGreen600,
    primary2Color: Colors.indigo700,
    accent1Color: Colors.lightGreen600,
    pickerHeaderColor: Colors.darkBlack,
    alternateTextColor: Colors.white
  },
  appBar: {
    height: 45
  }
});

const DropDownMenu = props => (
  <IconMenu
    iconButtonElement={
      <IconButton>
        <MoreVertIcon color="white" />
      </IconButton>
    }
    targetOrigin={{ horizontal: "right", vertical: "top" }}
    anchorOrigin={{ horizontal: "right", vertical: "top" }}
  >
    <MenuItem
      onClick={() => {
        props.PromenaPinaModalHandleOpen();
      }}
      rightIcon={<PinIcon />}
      primaryText="Promeni PIN"
    />
    <MenuItem
      rightIcon={<RadniciIconAdd />}
      onClick={() => {
        props.getNoviRadnik();
      }}
      primaryText="Dodaj radnika"
    />
    <MenuItem
      rightIcon={<RadniciIcon />}
      primaryText="Izmeni radnika"
      onClick={() => {
        props.getIzmeniRadnika();
      }}
    />
    <MenuItem
      containerElement={<Link to={"/Jelovnik/" + props.idFirme} />}
      rightIcon={<JelovnikIcon />}
      primaryText="Jelovnik"
    />
    <MenuItem
      rightIcon={<IzvestajiIcon />}
      onClick={() => {
        props.getPorudzbaTekuca();
      }}
      primaryText="Porudžba tekuća"
    />
    <MenuItem
      rightIcon={<IzvestajiIcon />}
      onClick={() => {
        props.getPorudzbaNaredna();
      }}
      primaryText="Porudžba naredna"
    />
    <MenuItem
      onClick={() => {
        props.putUpdateMenu();
      }}
      rightIcon={<RefreshIcon />}
      primaryText="Osveži jelovnik"
    />
  </IconMenu>
);

export default class CompanyDash extends React.Component {
  changePanelPoruka = (idFirme, text) => {
    idFirme = "PanelPoruka_" + idFirme;
    this.setState({ [idFirme]: text });
  };

  sentPanelPorukaToMobiles = idFirme => {
    try {
      this.props.sentPanelPoruka(idFirme);
    } catch (e) {
      alert("Poruke nisu poslate, pokušajte ponovo!")
    }
  };

  updatePanelPoruka = idFirme => {
    let state = "PanelPoruka_" + idFirme;
    try {
      this.props.putPanelPoruka(idFirme, this.state[state]);
    } catch (e) {
      console.log("Poruka nije menjana...");
    }
  };

  render() {
    return (
      <div
        className="firmaDash"
        style={{
          borderRadius: 5,
          WebkitFlex: "430px",
          marginBottom: 7,
          padding: 5,
          fontFamily: "Raleway,sans-serif",
          textAlign: "left",
          background: "rgb(232, 232, 232)",
          color: "rgba(0, 0, 0, 0.87)",
          fontSize: "14px",
          display: "flex",
          flexDirection: "column"
        }}
      >
        <MuiThemeProvider muiTheme={muiTheme}>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <Toolbar
              style={{
                borderRadius: 5,
                height: 38,
                marign: 0,
                padding: 5,
                background:
                  this.props.onlineStatus === "online"
                    ? "#1abc9c"
                    : this.props.onlineStatus === "loading" ? "#1abc9c" : "red"
              }}
            >
              <ToolbarGroup>
                <img
                  height="23"
                  width="52"
                  alt={""}
                  src={
                    "data:image/jpeg;base64," +
                    btoa(
                      String.fromCharCode(
                        ...new Uint8Array(this.props.logo["data"])
                      )
                    )
                  }
                />

                <ToolbarTitle
                  style={{
                    textAlign: "left",
                    marginLeft: 4,
                    color: "white",
                    fontSize: 19
                  }}
                  text={
                    this.props.onlineStatus === "online"
                      ? this.props.name + "  - Online"
                      : this.props.onlineStatus === "loading"
                        ? this.props.name + "  - Učitavam"
                        : this.props.name + "  - Offline"
                  }
                />
              </ToolbarGroup>
              <ToolbarGroup>
                <DropDownMenu
                  getPorudzbaNaredna={this.props.getPorudzbaNaredna}
                  getPorudzbaTekuca={this.props.getPorudzbaTekuca}
                  getNoviRadnik={this.props.getNoviRadnik}
                  getIzmeniRadnika={this.props.getIzmeniRadnika}
                  PromenaPinaModalHandleOpen={
                    this.props.PromenaPinaModalHandleOpen
                  }
                  putUpdateMenu={this.props.putUpdateMenu}
                  idFirme={this.props.idFirme}
                />
              </ToolbarGroup>
            </Toolbar>

            <label style={{ paddingTop: 5 }}>
              <label
                style={{
                  fontWeight: "bold",
                  paddingLeft: 5,
                  paddingTop: 50,
                  color: "rgba(0, 0, 0, 0.87)"
                }}
              >
                Pin:
              </label>{" "}
              {this.props.pin}
            </label>
            <label>
              <label
                style={{
                  fontWeight: "bold",
                  paddingLeft: 5,
                  color: "rgba(0, 0, 0, 0.87)"
                }}
              >
                Najtraženiji:
              </label>{" "}
              {this.props.favMeal}
            </label>
            <label>
              <label
                style={{
                  fontWeight: "bold",
                  paddingLeft: 5,
                  color: "rgba(0, 0, 0, 0.87)"
                }}
              >
                Najmanje tražen:
              </label>{" "}
              {this.props.unFavMeal}
            </label>
            <label>
              <label
                style={{
                  fontWeight: "bold",
                  paddingLeft: 5,
                  color: "rgba(0, 0, 0, 0.87)"
                }}
              >
                Rezervisano obroka trenutno*:
              </label>{" "}
              {this.props.numOfRes}{" "}
              ({this.props.numOfRes > this.props.rezervisanoProsleNedelje
                ? "📈"
                : "📉"} {Math.round((((this.props.rezervisanoProsleNedelje-this.props.numOfRes)/this.props.rezervisanoProsleNedelje)*100)*100)/100}%)
            </label>

            <label>
              <label
                style={{
                  fontWeight: "bold",
                  paddingLeft: 5,
                  color: "rgba(0, 0, 0, 0.87)"
                }}
              >
                Rezervisano obroka protekle nedelje:
              </label>{" "}
              {this.props.rezervisanoProsleNedelje}
            </label>

            <label>
              <label
                style={{
                  fontWeight: "bold",
                  paddingLeft: 5,
                  color: "rgba(0, 0, 0, 0.87)"
                }}
              >
                Iskorisćeno obroka protekle nedelje:
              </label>{" "}
              {this.props.iskoriscenoProsleNedelje}
            </label>

            <label>
              <label
                style={{
                  fontWeight: "bold",
                  paddingLeft: 5,
                  color: "rgba(0, 0, 0, 0.87)"
                }}
              >
                Aktivni korisnici mobilne aplikacije:
              </label>{" "}
              {this.props.brojKorisnikaMobilneAplikacije}
            </label>
            <label>
              <label
                style={{
                  fontWeight: "bold",
                  paddingLeft: 5,
                  color: "rgba(0, 0, 0, 0.87)"
                }}
              >
                Aktivni korisnici ukupno:
              </label>{" "}
              {this.props.brojAktivnihKorisnika}
            </label>

            <Card style={{ marginTop: 6, color: "rgba(0, 0, 0, 0.87)" }}>
              <CardHeader
                titleStyle={{
                  fontWeight: "bold",
                  paddingLeft: 0,
                  color: "#1abc9c"
                }}
                title="Panel poruka"
                actAsExpander={false}
                showExpandableButton={true}
              />
              <CardText expandable={true}>
                <TextField
                  hintText="Poruka koju radnici mogu videti na početnom ekranu u kantini..."
                  multiLine={true}
                  rows={6}
                  defaultValue={this.props.panelPoruka}
                  fullWidth={true}
                  style={{ width: "100%" }}
                  onChange={(e, newValue) =>
                    this.changePanelPoruka(this.props.idFirme, newValue)
                  }
                />
              </CardText>
              <CardText
                style={{ float: "left" }}
                actAsExpander={true}
                expandable={true}
              >
                <NotifyIcon
                  onClick={() => this.sentPanelPorukaToMobiles(this.props.idFirme)}
                  color={"#1abc9c"}
                />
              </CardText>
              <CardText
                style={{ float: "right" }}
                actAsExpander={true}
                expandable={true}
              >
                <EditIcon
                  onClick={() => this.updatePanelPoruka(this.props.idFirme)}
                  color={"#1abc9c"}
                />
              </CardText>
            </Card>
          </div>
        </MuiThemeProvider>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Dash/CompanyDash.js